import React, { useState } from 'react';
import Select from 'react-select';
import SmallAddButton from "../Atom/Buttons/SmallAddButton";
import { dashboardColors, theme } from '../../themes/Theme';

// Sample options
const options = [
    { value: 'option1', label: 'Option 1' },
    { value: 'option2', label: 'Option 2' },
    { value: 'option3', label: 'Option 3' },
];

const customStyles = {
    option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        background: isSelected ? dashboardColors[theme].primary : isFocused ? "#e2e8f0" : "white",
        margin: "0px",
        color: isSelected ? "white" : isFocused ? "#1a202c" : "#4a5568",
        zIndex: 10,
        overflowX: "hidden",
        wordBreak: "break-word",
        cursor: "pointer",
    }),
    menu: (provided) => ({
        ...provided,
        marginTop: "2px",
        overflow: "hidden",
        zIndex: 10,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensure the portal has high z-index
    dropdownIndicator: (base) => ({
        ...base,
        color: dashboardColors[theme].primaryTextColor,
        padding: "5px 8px",
        "&:hover": {
            color: dashboardColors[theme].primaryTextColor,
        },
    }),
    control: (base, state) => ({
        ...base,
        border: state.isFocused ? `1px solid ${dashboardColors[theme].primary}` : "1px solid #cdd4db",
        boxShadow: "none",
        borderRadius: "2px",
        minHeight: "36px",
        maxHeight: "2.5em",
    }),
    placeholder: (base) => ({
        ...base,
        fontSize: "0.9rem",
    }),
};

// Custom Option Component for the "Add" button
const AddOption = ({ addOptionClickHandler, addButtonText, innerProps }) => {
    const handleAddButtonClick = (e) => {
        e.stopPropagation();
        addOptionClickHandler();
    };

    return (
        <div {...innerProps} style={{ width: "100%", height: "44px" }} className='d-flex'>
            <SmallAddButton
                onClick={(e) => handleAddButtonClick(e)}
                btnType="secondary"
                className="px-3"
            >
                {addButtonText}
            </SmallAddButton>
        </div>
    );
};

// Custom Option Component
const CustomOption = ({ addButtonText, addOptionClickHandler, innerProps, label, data, isFocused, isSelected }) => {
    const optionStyles = {
        background: isSelected ? dashboardColors[theme].primary : isFocused ? "#e2e8f0" : "white",
        margin: "0px",
        color: isSelected ? "white" : isFocused ? "#1a202c" : "#4a5568",
        zIndex: 10,
        overflowX: "hidden",
        wordBreak: "break-word",
        cursor: "pointer",
        padding: "10px 15px",
    };

    if (data.isAddOption) {
        return <AddOption addOptionClickHandler={addOptionClickHandler} addButtonText={addButtonText} innerProps={innerProps} />;
    }

    return (
        <div {...innerProps} style={optionStyles}>
            {label}
        </div>
    );
};

// Main Component
const DropDownSearch = ({
    name,
    addOptionClickHandler,
    DropDownOptions,
    value,
    onChange,
    onBlur,
    isDisabled = false,
    setFieldValue,
    addButtonText,
    placeholder
}) => {
    const [inputValue, setInputValue] = useState('');

    const handleChange = (selected) => {
        if (selected.label == "Add") {
            addOptionClickHandler();
        } else {
            onChange(selected);
            setFieldValue(name, selected);
        }
    };

    const handleInputChange = (value) => {
        setInputValue(value);
    };

    // Filter options based on search input
    const filteredOptions = DropDownOptions?.filter((option) =>
        option?.label?.toLowerCase()?.includes(inputValue?.toLowerCase())
    );

    // Always include the "Add" button as an option
    const optionsWithAddButton = [
        ...filteredOptions,
        { value: 'add', label: 'Add', isAddOption: true },
    ];

    return (
        <>
            <Select
                name={name}
                value={value?.value ? value : null}
                onChange={handleChange}
                onBlur={onBlur}
                options={optionsWithAddButton}
                onInputChange={handleInputChange}
                components={{
                    Option: (props) => <CustomOption {...props} addOptionClickHandler={addOptionClickHandler} addButtonText={addButtonText} />
                }}
                isDisabled={isDisabled}
                isSearchable
                placeholder={placeholder}
                noOptionsMessage={() => null}
                filterOption={null}
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPlacement="auto"
            />
        </>
    );
};

export default DropDownSearch;